import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';
const switchTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  switchTheme[item] = {
    switch: {
      thHeadColor: comm.color.cffff,
      bgColor: base[item]?.switchColor.c0025,
    },
  };
}

export const switchTh = switchTheme;
